/*
 * AddMember Messages
 *
 * This contains all the text for the AddMember component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.AddMember';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Add New Members',
  },
  invite: {
    id: `${scope}.invite`,
    defaultMessage: 'Invite',
  },
  inviteMember: {
    id: `${scope}.inviteMember`,
    defaultMessage: 'Invite member',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Add members',
  },
  spaceMembers: {
    id: `${scope}.spaceMembers`,
    defaultMessage: 'Space Members',
  },
});
